"use client";
'use strict';

var React = require('react');
var DeviceInfoProvider = require('../providers/DeviceInfoProvider.js');

/**
 * React hook that help checking user device
 *
 * @example
 * ```javascript
 * const isMobile = useIsMobile()
 * const isTablet = useIsTablet()
 * const isPhone = useIsPhone()
 * const isAppleMobile = useIsAppleMobile()
 * ```
 */
function useDeviceInfoContext() {
    return React.useContext(DeviceInfoProvider.DeviceInfoContext);
}
function useIsPhone() {
    const { phone } = useDeviceInfoContext();
    return phone;
}
function useIsTablet() {
    const { tablet } = useDeviceInfoContext();
    return tablet;
}
function useIsMobile() {
    const { phone, tablet } = useDeviceInfoContext();
    return phone || tablet;
}
function useIsAppleMobile() {
    const { isAppleMobile } = useDeviceInfoContext();
    return isAppleMobile;
}

exports.useDeviceInfoContext = useDeviceInfoContext;
exports.useIsAppleMobile = useIsAppleMobile;
exports.useIsMobile = useIsMobile;
exports.useIsPhone = useIsPhone;
exports.useIsTablet = useIsTablet;
//# sourceMappingURL=useDeviceInfo.js.map
